import React, { useState, useEffect, useContext } from "react";

import { AddFilter, DeleteFilter, DropArrow, EditFilter, SearchIcon, SearchIconWhite } from "../../assets/images";

import {
  getDeviceTypeList,
} from "../../services/configurationServices";
import {
  addNotifs,
  deleteNotifs,
  getEmergencyContactList,
  getMentionsList,
  getNotifById,
  getNotifs,
  updateNotifs,
} from "../../services/notifService";

import { Mention, MentionsInput } from "react-mentions";
import { MultiSelect } from "react-multi-select-component";
import Swal from "sweetalert2";

import mentionsInputStyles from "./mentionsInputStyles";
import mentionStyles from "./mentionStyles";
import RegisteredUsers from "./RegisteredUsers";
import CustomContact from "./CustomContact";
import { WarningToast } from "../../CustomHooks/WarningToast";
import { SuccessToast } from "../../CustomHooks/SuccessToast";
import { ErrorToast } from "../../CustomHooks/ErrorToast";
import EmergencyContact from "./EmergencyContact";

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import EditModalContainer from "./EditModalContainer";
import { getSiteList } from "../../services/alertGridServices";
import { useAlertType } from "../../CustomHooks/useAlertType";
import { ConfigurationContext } from "../../Context/ConfigurationContext";

const REALTIME = "REALTIME";
const DAILY = "DAILY";
const HOURLY = "HOURLY";
const WEEKLY = "WEEKLY";
const MONTHLY = "MONTHLY";
const SMS = "SMS";
const MOBILE = "MOBILE"

let clist = [
  {
    id: 0,
    name: "Customer(s)",
    selected: true,
    menuOpen: false,
    selectedCount: 0,
    totalCount: 0,
    identifier: "customer"
  },
  {
    id: 1,
    name: "Country(s)",
    selected: false,
    menuOpen: false,
    selectedCount: 0,
    totalCount: 0,
    identifier: "country"
  },
  {
    id: 2,
    name: "State(s)",
    selected: false,
    menuOpen: false,
    selectedCount: 0,
    totalCount: 0,
    identifier: "state"
  },
  {
    id: 3,
    name: "City(s)",
    selected: false,
    menuOpen: false,
    selectedCount: 0,
    totalCount: 0,
    identifier: "city"
  },
  {
    id: 4,
    name: "Region(s)",
    selected: false,
    menuOpen: false,
    selectedCount: 0,
    totalCount: 0,
    identifier: "region"
  },
  {
    id: 5,
    name: "Pin code(s)",
    selected: false,
    menuOpen: false,
    selectedCount: 0,
    totalCount: 0,
    identifier: "pincode"
  },
  {
    id: 6,
    name: "Area(s)",
    selected: false,
    menuOpen: false,
    selectedCount: 0,
    totalCount: 0,
    identifier: "area"
  },
  {
    id: 7,
    name: "Site(s)",
    selected: false,
    menuOpen: false,
    selectedCount: 0,
    totalCount: 0,
    identifier: "site"
  },
  {
    id: 8,
    name: "Branch ID(s)",
    selected: false,
    menuOpen: false,
    selectedCount: 0,
    totalCount: 0,
    identifier: "branchid"
  },
  {
    id: 9,
    name: "Device Type(s)",
    selected: false,
    menuOpen: false,
    selectedCount: 0,
    totalCount: 0,
    identifier: "devicetype"
  },
  {
    id: 10,
    name: "Device(s)",
    selected: false,
    menuOpen: false,
    selectedCount: 0,
    totalCount: 0,
    identifier: "device"
  },
]
const NotificationContainer = ({
  addNewClicked,
  setAddNewClicked,
  isNotifFormEnabled,
  setIsNotifFormEnabled,
  notifSaveBtnClicked,
  notifDeleteBtnClicked,
  setNotifSaveBtnClicked,
  setNotifDeleteBtnClicked,
  setIsEmptyForm,
  isDarkTheme,
  setButtonDisable
}) => {
  const { clients } = useContext(ConfigurationContext)

  //region useState start
  const [selectedSiteTab, setSelectedSiteTab] = useState("realTime");
  const [notifList, setNotifList] = useState([]);
  const [notifSearch, setNotifSearch] = useState("");
  const [notificationName, setNotificationName] = useState("");
  const [emergencyContact, setEmergencyContact] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState({
    id: 0,
    name: "Customer(s)",
    selected: true,
    menuOpen: false,
    selectedCount: 0,
    totalCount: 0
  });
  const [unselectedTemp, setUnSelectedTemp] = useState([]);
  const [unselectedTempFiltered, setUnSelectedTempFiltered] = useState([]);
  const [selectedTemp, setSelectedTemp] = useState([]);
  const [selectedTempFiltered, setSelectedTempFiltered] = useState([]);
  const [isLeftItemSelected, setIsLeftItemSelected] = useState(false);
  const [isRightItemSelected, setIsRightItemSelected] = useState(false);

  const [searchTextOne, setSearchTextOne] = useState("");
  const [searchTextTwo, setSearchTextTwo] = useState("");
  const [searchTextThree, setSearchTextThree] = useState("");
  const [searchTextFour, setSearchTextFour] = useState("");
  const [isLeftSearch, setIsLeftSearch] = useState(false);
  const [isRightSearch, setIsRightSearch] = useState(false);

  const [checkOne, setCheckOne] = useState(false);
  const [checkTwo, setCheckTwo] = useState(false);
  const [topLeftCheck, setTopLeftCheck] = useState(false);
  const [topRightCheck, setTopRightCheck] = useState(false);
  const [midLeftCheck, setMidLeftCheck] = useState(false);
  const [midRightCheck, setMidRightCheck] = useState(false);

  const [finalChildId, setFinalChildId] = useState(0);
  const [finalParentId, setFinalParentId] = useState(0);
  const [finalEntity, setFinalEntity] = useState("");

  const [sampleCount, setSampleCount] = useState(0);
  const [isEditCustomer, setIsEditCustomer] = useState(false);
  const [customContact, setCustomContact] = useState([
    {
      Id: 0,
      Name: "",
      Designation: "",
      ContactNumber: "",
      ContactEmail: "",
    },
  ]);
  const [mentionList, setMentionList] = useState([]);
  //Email Notification Template State Values Start
  const [realTimeEnabled, setRealTimeEnabled] = useState(false);
  const [realTimeSubject, setRealTimeSubject] = useState("");
  const [mentionRealTimeSubject, setMentionRealTimeSubject] = useState("");
  const [realTimeMessage, setRealTimeMessage] = useState("");
  const [mentionRealTimeMessage, setMentionRealTimeMessage] = useState("");

  const [hourlyEnabled, setHourlyEnabled] = useState(false);
  const [mentionHourlySubject, setMentionHourlySubject] = useState("");
  const [mentionHourlyMessage, setMentionHourlyMessage] = useState("");

  const [dailyEnabled, setDailyEnabled] = useState(false);
  const [mentionDailySubject, setMentionDailySubject] = useState("");
  const [mentionDailyMessage, setMentionDailyMessage] = useState("");

  const [weeklyEnabled, setWeeklyEnabled] = useState(false);
  const [mentionWeeklySubject, setMentionWeeklySubject] = useState("");
  const [mentionWeeklyMessage, setMentionWeeklyMessage] = useState("");

  const [monthlyEnabled, setMonthlyEnabled] = useState(false);
  const [mentionMonthlySubject, setMentionMonthlySubject] = useState("");
  const [mentionMonthlyMessage, setMentionMonthlyMessage] = useState("");
  //Email Notification Template State Values End

  const [userList, setUserList] = useState([]);
  const [selectedUsersList, setSelectedUsersList] = useState([]);
  const [siteListString, setSiteListString] = useState("");
  const [mainCustomerList, setMainCustomerList] = useState([
    {
      Id: 0,
      Name: "",
      Designation: "",
      ContactNumber: "",
      ContactEmail: "",
    },
  ]);
  const [count, setCount] = useState(0);
  const [enableAdd, setEnableAdd] = useState(false);
  const [siteSelected, setSiteSelected] = useState([]);
  const [deviceTypeSelected, setDeviceTypeSelected] = useState([]);
  const [eventCodeSelected, setEventCodeSelected] = useState([]);
  const [siteListData, setSiteListData] = useState([]);
  const [deviceTypeListData, setDeviceTypeListData] = useState([]);
  const [selectedNotifObj, setSelectedNotifObj] = useState(null);
  const [selectedAllRegUsers, setSelectedAllRegUsers] = useState(false);
  const [notificationCustomerError, setNotificationCustomerError] = useState("")
  const [notificationNameError, setNotificationNameError] = useState("");
  const [notificationSiteError, setNotificationSiteError] = useState("");
  const [customerSelected, setCustomerSelected] = useState(0)
  const [notificationDeviceTypeError, setNotificationDeviceTypeError] = useState("");
  const [notificationEventcodeError, setNotificationEventCodeError] = useState("");
  const [customerList, setCustomerList] = useState(clist);
  const [siteList, setSiteList] = useState([]);
  const [customerListSingle, setCustomerListSingle] = useState([]);
  const { alertTypeOptions } = useAlertType()
  const [mentionSMSMessage, setMentionSMSMessage] = useState("");
  const [smsMessage, setSMSMessage] = useState("");
  const [mentionMobileMessage, setMentionMobileMessage] = useState("");
  const [mobileMessage, setMobileMessage] = useState("");
  const [siteSelectedArr, setSiteSelectedArr] = useState([])
  const [countkey, setCountKey] = useState(0)
  const [emergencyContactList, setEmergencyContactList] = useState([])

  const [uniqueCount, setUniqueCount] = useState(0);
  const [categoryMaster, setCategoryMaster] = useState([])
  const [selectedEmergCont, setSelectedEmergCont] = useState([
    {
      categoryChecked: 1,
      contactLevels: ["1", "3"]
    }
  ]);
  //region useState end

  // const eventCodeListArray = [
  //   { label: "Online", value: "1" },
  //   { label: "Offline", value: "2" },
  // ];

  const siteListArray = siteListData.map((site) => ({
    value: site.SiteID,
    label: site.SiteName,
  }));

  const deviceTypeListArray = deviceTypeListData.map((device) => ({
    value: device.DeviceTypeID,
    label: device.DeviceType,
  }));

  //region useEffect start
  useEffect(() => {
    getSiteListFn(customerSelected)
  }, [customerSelected, countkey]);


  useEffect(() => {
    getNotificationList();
  }, []);

  useEffect(() => {
    let temp = siteSelected.map((item) => item.value).join(",");
    let oldString = siteListString;
    let oldArr = siteListString.split(",");
    let newArr = temp.split(",");
    if (oldArr.length > newArr.length) {
      let diff = oldArr.filter((e) => !newArr.includes(e));
      let anotherTempArr = selectedUsersList;
      for (let i = 0; i < diff.length; i++) {
        anotherTempArr = anotherTempArr.filter((item) => item.Item2 != diff[i]);
      }
      setSelectedUsersList(anotherTempArr);
    }
    setSiteListString(temp);
  }, [siteSelected]);

  useEffect(() => {
    if (siteListString != "") {
      //if(true){
      let temp;
      let loggedInUser = JSON.parse(localStorage.getItem('user'))
      temp = loggedInUser?.Id

      // Comment the below or make it false if you want don't want to check via the dummy data.
      if (false) {

        let dummy = [{
          "Category": "1",
          "ContactLevel": [
            1,
            2,
            3
          ]
        },
        {
          "Category": "2",
          "ContactLevel": [
            1,
            2
          ]
        }, {
          "Category": "3",
          "ContactLevel": [
            1
          ]
        }]

        let arr = dummy.map((item) => {
          let obj = {
            "Category": item.Category,
            "CategorySelected": false,
            "ContactLevel": item.ContactLevel.map(contactId => ({
              "contactId": contactId,
              "contactSelected": false
            }))
          }
          return obj
        });

        let tempArr = arr.map((item) => {
          let obj
          let isPresent = false
          let str = []
          for (let i = 0; i < selectedEmergCont.length; i++) {
            if (item.Category == selectedEmergCont[i].categoryChecked) {
              isPresent = true
              str = selectedEmergCont[i].contactLevels
              break;
            }
          }
          if (isPresent) {
            obj = {
              ...item,
              "CategorySelected": true,
              "ContactLevel": item.ContactLevel.map(contactId => ({
                "contactId": contactId.contactId,
                "contactSelected": str.includes(contactId.contactId.toString())
              }))
            }
          } else {
            obj = {
              ...item
            }
          }
          return obj
        });

        setEmergencyContactList(tempArr)
        setCategoryMaster(tempArr)

      }

      // Comment the below if you want to check via the dummy data.

      getEmergencyContactList(temp, siteListString).then((res) => {
        if (res.Status == "success") {
          let arr = res.Data.map((item) => {
            let obj = {
              "Category": item.Category,
              "CategorySelected": false,
              "ContactLevel": item.ContactLevel.map(contactId => ({
                "contactId": contactId,
                "contactSelected": false
              }))
            }
            return obj
          });

          let tempArr = arr.map((item) => {
            let obj
            let isPresent = false
            let str = []
            for (let i = 0; i < selectedEmergCont.length; i++) {
              if (item.Category == selectedEmergCont[i].categoryChecked) {
                isPresent = true
                str = selectedEmergCont[i].contactLevels
                break;
              }
            }
            if (isPresent) {
              obj = {
                ...item,
                "CategorySelected": true,
                "ContactLevel": item.ContactLevel.map(contactId => ({
                  "contactId": contactId.contactId,
                  "contactSelected": str.includes(contactId.contactId.toString())
                }))
              }
            } else {
              obj = {
                ...item
              }
            }
            return obj
          });
          console.log("tempArr", tempArr)
          setEmergencyContactList(tempArr)
          setCategoryMaster(tempArr)

        } else {
          setCategoryMaster([])
          setEmergencyContactList([])
        }
      })
        .catch((err) => console.log(err));

    } else {
      setCategoryMaster([])
      setEmergencyContactList([])
    }
  }, [siteListString, uniqueCount])

  useEffect(() => {
    if (notifSaveBtnClicked) {
      setNotifSaveBtnClicked(false);
      //Call Function for adding
      addNotification();
    }
  }, [notifSaveBtnClicked]);

  useEffect(() => {
    if (!isNotifFormEnabled && selectedNotifObj === null) {
      clearInputFields();
    }
    if (!isNotifFormEnabled && selectedNotifObj !== null) {
      getNotificationById(selectedNotifObj);
      clearNotificationFields();
    }
  }, [isNotifFormEnabled]);

  useEffect(() => {
    if (notifDeleteBtnClicked) {
      //Call Function to delete the Noti
      deleteNotification();
    }
  }, [notifDeleteBtnClicked]);

  useEffect(() => {
    getMentionsList()
      .then((res) => {
        if (res.Status == "success") {
          setMentionList(res.Data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (addNewClicked) {
      //Empty all the fields(
      clearInputFields();
    }
  }, [addNewClicked]);

  useEffect(() => {
    //getSiteListFn();
    getDeviceTypeListFn();
  }, []);

  useEffect(() => {
    setCustomerList(clist);
  }, []);

  //region useEffect end

  //region function start

  const clearNotificationFields = () => {
    setNotificationCustomerError("")
    setNotificationNameError("");
    setNotificationSiteError("");
    setNotificationDeviceTypeError("");
    setNotificationEventCodeError("");
  };

  const deleteNotification = () => {
    setButtonDisable(true);
    if (selectedNotifObj == null) {
      WarningToast("Kindly select a notification to delete it.");
      return;
    }
    try {
      Swal.fire({
        title: "Are you sure?",
        //text: "Deleting this data access group will delete all the associations related to it!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#027aaa",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          let updateObj = {
            NotificationConfigurationID:
              selectedNotifObj.NotificationConfigurationID,
            NotificationtemplateName: notificationName,
            NotificationConfigurationDetail: {
              LstCustomer: (""),
              LstSites: [""],
              LstDeviecType: [""],
              LstEventCode: [""],
              LstNotificationTemplateEmail: [
                {
                  Subject: "",
                  Body: "",
                  Type: "RealTime",
                  IsEnabled: realTimeEnabled.toString(),
                },
                {
                  Subject: "",
                  Body: "",
                  Type: "Hourly",
                  IsEnabled: hourlyEnabled.toString(),
                },
                {
                  Subject: "",
                  Body: "",
                  Type: "Daily",
                  IsEnabled: dailyEnabled.toString(),
                },
                {
                  Subject: "",
                  Body: "",
                  Type: "Weekly",
                  IsEnabled: weeklyEnabled.toString(),
                },
                {
                  Subject: "",
                  Body: "",
                  Type: "Monthly",
                  IsEnabled: monthlyEnabled.toString(),
                },
              ],
              EmergencyContact: "",
              LstUserSite: [
                {
                  Item1: "",
                  Item2: "",
                },
              ],
              LstCustomContact: [
                {
                  Id: "",
                  Name: "",
                  Designation: "",
                  ContactNumber: "",
                  ContactEmail: "",
                },
              ],
            },
          };
          let userId = localStorage.getItem("UserID");
          deleteNotifs(userId, selectedNotifObj.NotificationConfigurationID)
            .then((res) => {
              if (res.Status == "success") {
                setButtonDisable(false);
                SuccessToast(res.Message);
                getNotificationList();
                setNotifDeleteBtnClicked(false);
                clearInputFields();
                setIsNotifFormEnabled(true);
                setIsEmptyForm(true);
              }
            })
            .catch((err) => console.log(err));
        } else {
          setButtonDisable(false);
          setNotifDeleteBtnClicked(false);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const addNotification = () => {
    // const transformedDataSample = categoryMaster
    //   .filter(item => item.CategorySelected)  // Only include categories where CategorySelected is true
    //   .map(item => ({
    //     categoryChecked: item.Category,  // Convert Category to number
    //     contactLevels: item.ContactLevel
    //       .filter(contact => contact.contactSelected)  // Filter contacts where contactSelected is true
    //       .map(contact => contact.contactId.toString())  // Convert contactId to string
    //   }));
    setButtonDisable(true);
    let validationError = "";
    if (notificationName == "") {
      validationError +=
        "notification name-Kindly enter a name for the template!,";
    }
    if (customerSelected == 0) {
      validationError += "notification customer-Kindly select some customer!,";
    }
    // let tempCustomer = customerSelected.map((item) => item.value);

    if (siteSelected.length === 0) {
      validationError += "notification site-Kindly select some sites!,";
    }
    let tempSites = siteSelected.map((item) => item.value);

    // if (deviceTypeSelected.length === 0) {
    //   validationError += "notification device-Kindly select a type of device!,";
    // }
    // let tempDeviceTypes = deviceTypeSelected.map((item) => item.value);

    if (eventCodeSelected.length === 0) {
      validationError += "notification event-Kindly select a type of event!,";
    }

    let templst = validationError.split(",");
    for (let i = 0; i < templst.length; i++) {
      if (templst[i].includes("notification name-")) {
        setNotificationNameError(templst[i].replace("notification name-", ""));
        continue;
      }
      if (templst[i].includes("notification customer-")) {
        setNotificationCustomerError(templst[i].replace("notification customer-", ""));
        continue;
      }

      if (templst[i].includes("notification site-")) {
        setNotificationSiteError(templst[i].replace("notification site-", ""));
        continue;
      }
      // if (templst[i].includes("notification device-")) {
      //   setNotificationDeviceTypeError(
      //     templst[i].replace("notification device-", "")
      //   );
      //   continue;
      // }
      if (templst[i].includes("notification event-")) {
        setNotificationEventCodeError(
          templst[i].replace("notification event-", "")
        );
        continue;
      }
    }
    if (validationError != "") {
      setButtonDisable(false);
      return;
    }

    let tempEventType = eventCodeSelected.map((item) => item.value.toString());

    if (
      realTimeEnabled &&
      (mentionRealTimeSubject === "" || mentionRealTimeMessage === "")
    ) {
      ErrorToast("Kindly fill the real time email notification template");
      setButtonDisable(false);
      return;
    }

    if (mentionRealTimeSubject === "" || mentionRealTimeMessage === "") {
      ErrorToast("Kindly fill the real time email notification template");
      setButtonDisable(false);
      return;
    }

    if (
      hourlyEnabled &&
      (mentionHourlySubject === "" || mentionHourlyMessage === "")
    ) {
      ErrorToast("Kindly fill the hourly email notification template");
      setButtonDisable(false);
      return;
    }

    if (
      dailyEnabled &&
      (mentionDailySubject === "" || mentionDailyMessage === "")
    ) {
      ErrorToast("Kindly fill the daily email notification template");
      setButtonDisable(false);
      return;
    }

    if (
      weeklyEnabled &&
      (mentionWeeklySubject === "" || mentionWeeklyMessage === "")
    ) {
      ErrorToast("Kindly fill the weekly email notification template");
      setButtonDisable(false);
      return;
    }

    if (
      monthlyEnabled &&
      (mentionMonthlySubject === "" || mentionMonthlyMessage === "")
    ) {
      ErrorToast("Kindly fill the monthly email notification template");
      setButtonDisable(false);
      return;
    }

    if (
      monthlyEnabled &&
      (mentionSMSMessage === "")
    ) {
      ErrorToast("Kindly fill the sms notification template");
      setButtonDisable(false);
      return;
    }

    if (
      monthlyEnabled &&
      (mentionMobileMessage === "")
    ) {
      ErrorToast("Kindly fill the mobile notification template");
      setButtonDisable(false);
      return;
    }

    setEnableAdd(false);
    let lastForm = mainCustomerList[mainCustomerList.length - 1];
    let contactNameEntered = lastForm?.Name;
    let contactEmailEntered = lastForm?.ContactEmail;
    let contactNumberEntered = lastForm?.ContactNumber;
    const emailPattern = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm;

    if (contactNameEntered && contactEmailEntered && contactNumberEntered) {
      if (enableAdd) {
        WarningToast("Please complete the contact details to add another");
      } else {
        if (emailPattern.test(contactEmailEntered)) {
          // Valid email logic
        } else {
          ErrorToast("Please enter email id properly");
          setButtonDisable(false);
          return;
        }
        if (contactNumberEntered.length !== 10) {
          ErrorToast("Please enter contact number properly");
          setButtonDisable(false);
          return;
        }
      }
    }

    let isEmptyFields = false;
    if (mainCustomerList.length === 1) {
      for (let x = 0; x < mainCustomerList.length; x++) {
        if (
          (mainCustomerList[x].Name == "" ||
            mainCustomerList[x].ContactNumber == "" ||
            mainCustomerList[x].ContactEmail == "") &&
          !(
            mainCustomerList[x].Name == "" &&
            mainCustomerList[x].ContactNumber == "" &&
            mainCustomerList[x].ContactEmail == "" &&
            mainCustomerList[x].Designation == ""
          )
        ) {
          ErrorToast("Kindly complete the custom contact details.");
          setButtonDisable(false);
          return;
        }
      }
    } else {
      for (let x = 0; x < mainCustomerList.length; x++) {
        if (
          mainCustomerList[x].Name == "" ||
          mainCustomerList[x].ContactNumber == "" ||
          mainCustomerList[x].ContactEmail == ""
        ) {
          ErrorToast("Kindly complete the custom contact details.");
          setButtonDisable(false);
          return;
        }
      }
    }

    let tempEmergencyContact;
    if (emergencyContact) {
      tempEmergencyContact = "yes";
    } else {
      tempEmergencyContact = "no";
    }

    let tempCustomContact = mainCustomerList.map((item) => {
      let obj = {
        ...item,
        Id: item.Id.toString(),
      };
      return obj;
    });

    const transformedData = categoryMaster
      .filter(item => item.CategorySelected)  // Only include categories where CategorySelected is true
      .map(item => ({
        categoryChecked: item.Category,  // Convert Category to number
        contactLevels: item.ContactLevel
          .filter(contact => contact.contactSelected)  // Filter contacts where contactSelected is true
          .map(contact => contact.contactId.toString())  // Convert contactId to string
      }));
      let user = JSON.parse(localStorage.getItem("user"));
    if (selectedNotifObj === null) {
      // Add Part
      let obj = {
        UserId: user?.Id,
        NotificationtemplateName: notificationName
          .replaceAll("\\", "\\\\")
          .replaceAll("'", `''`)
          .replaceAll('"', '\\"'),
        NotificationConfigurationDetail: {
          LstCustomer: customerSelected,
          LstSites: tempSites,
          // LstDeviecType: tempDeviceTypes,
          LstEventCode: tempEventType,
          LstNotificationTemplateEmail: [
            {
              Subject: mentionRealTimeSubject
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Body: mentionRealTimeMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Type: "RealTime",
              IsEnabled: realTimeEnabled.toString(),
            },
            {
              Subject: mentionHourlySubject
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Body: mentionHourlyMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Type: "Hourly",
              IsEnabled: hourlyEnabled.toString(),
            },
            {
              Subject: mentionDailySubject
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Body: mentionDailyMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Type: "Daily",
              IsEnabled: dailyEnabled.toString(),
            },
            {
              Subject: mentionWeeklySubject
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Body: mentionWeeklyMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Type: "Weekly",
              IsEnabled: weeklyEnabled.toString(),
            },
            {
              Subject: mentionMonthlySubject
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Body: mentionMonthlyMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Type: "Monthly",
              IsEnabled: monthlyEnabled.toString(),
            },
          ],
          LstNotificationTemplateSMS: [
            {
              Body: mentionSMSMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
            }
          ],
          LstNotificationTemplateMobile: [
            {
              Body: mentionMobileMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
            }
          ],
          EmergencyContact: tempEmergencyContact,
          LstEmergencyContact: transformedData,
          LstUserSite: selectedUsersList,
          LstCustomContact: tempCustomContact,
        },
      };
      addNotifs(obj)
        .then((res) => {
          if (res.Status == "success") {
            setButtonDisable(false);
            SuccessToast(res.Message);
            getNotificationList();
            clearInputFields();
            setNotifSaveBtnClicked(false);
          } else {
            setButtonDisable(false);
            ErrorToast(res.Message);
          }
        })
        .catch((err) => console.log(err));
    } else {
      // Update Part
      let updateObj = {
        NotificationConfigurationID:
          selectedNotifObj.NotificationConfigurationID.toString(),
        NotificationtemplateName: notificationName
          .replaceAll("\\", "\\\\")
          .replaceAll("'", `''`)
          .replaceAll('"', '\\"'),
        NotificationConfigurationDetail: {
          LstCustomer: customerSelected,
          LstSites: tempSites,
          //LstDeviecType: tempDeviceTypes,
          LstEventCode: tempEventType,
          LstNotificationTemplateEmail: [
            {
              Subject: mentionRealTimeSubject
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Body: mentionRealTimeMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Type: "RealTime",
              IsEnabled: realTimeEnabled.toString(),
            },
            {
              Subject: mentionHourlySubject
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Body: mentionHourlyMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Type: "Hourly",
              IsEnabled: hourlyEnabled.toString(),
            },
            {
              Subject: mentionDailySubject
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Body: mentionDailyMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Type: "Daily",
              IsEnabled: dailyEnabled.toString(),
            },
            {
              Subject: mentionWeeklySubject
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Body: mentionWeeklyMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Type: "Weekly",
              IsEnabled: weeklyEnabled.toString(),
            },
            {
              Subject: mentionMonthlySubject
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Body: mentionMonthlyMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
              Type: "Monthly",
              IsEnabled: monthlyEnabled.toString(),
            },
          ],
          LstNotificationTemplateSMS: [
            {
              Body: mentionSMSMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
            }
          ],
          LstNotificationTemplateMobile: [
            {
              Body: mentionMobileMessage
                .replaceAll("\\", "\\\\")
                .replaceAll("'", `''`)
                .replaceAll('"', '\\"'),
            }
          ],
          EmergencyContact: tempEmergencyContact,
          LstEmergencyContact: transformedData,
          LstUserSite: selectedUsersList,
          LstCustomContact: tempCustomContact,
        },
      };
      updateNotifs(updateObj)
        .then((res) => {
          if (res.Status == "success") {
            setButtonDisable(false);
            SuccessToast(res.Message);
            getNotificationList();
            setIsNotifFormEnabled(false);
            setNotifSaveBtnClicked(false);
          } else {
            setButtonDisable(false);
            ErrorToast(res.Message);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  console.log("userList", userList)

  const getNotificationList = () => {
    getNotifs()
      .then((res) => {
        if (res.Status == "success") {
          setNotifList(res.Data);
        } else {
        }
      })
      .catch((err) => console.log(err));
  };

  const getSiteListFn = (clientIds) => {
    try {
      getSiteList(clientIds).then((resp) => {
        if (resp != undefined) {
          console.log("resppp", resp.Data)
          if (resp.Status == "success") {
            if (resp.Data == null) {
              setSiteListData([]);
            } else {
              setSiteListData(resp.Data.filter(i => i.ParentID == null));
              if (selectedNotifObj != null) {
                let temp = resp.Data.filter(i => i.ParentID == null).map((site) => ({
                  value: site.SiteID,
                  label: site.SiteName,
                }));
                console.log("temp",temp)
                let siteTempArr = temp.filter((site) =>
                  selectedNotifObj.NotificationConfigurationDetail.LstSites.includes(site.value)
                );
                console.log("temp1",siteTempArr)
                setSiteSelected(siteTempArr);
              }
            }

          } else {
            setSiteListData([]);
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getDeviceTypeListFn = () => {
    try {
      var obj = {
        type: "devicetype",
        params: {},
      };
      getDeviceTypeList(obj).then((resp) => {
        if (resp != undefined) {
          if (resp.Status == "success") {
            setDeviceTypeListData(resp.Data);
          } else {
            setDeviceTypeListData([]);
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const clearInputFields = () => {
    setNotificationName("");
    setCustomerSelected(0)
    setSiteSelected([]);
    setSiteListString("");
    setDeviceTypeSelected([]);
    setEventCodeSelected([]);
    setRealTimeEnabled(false);
    setRealTimeSubject("");
    setMentionRealTimeSubject("");
    setRealTimeMessage("");
    setSMSMessage("");
    setMobileMessage("")
    setMentionRealTimeMessage("");
    setHourlyEnabled(false);
    setMentionHourlySubject("");
    setMentionHourlyMessage("");
    setDailyEnabled(false);
    setMentionDailySubject("");
    setMentionDailyMessage("");
    setWeeklyEnabled(false);
    setMentionWeeklySubject("");
    setMentionWeeklyMessage("");
    setMonthlyEnabled(false);
    setMentionMonthlySubject("");
    setMentionMonthlyMessage("");
    setEmergencyContact(false);
    setSelectedUsersList([]);
    setUserList([]);
    setCustomContact([
      {
        Id: 1,
        Name: "",
        Designation: "",
        ContactNumber: "",
        ContactEmail: "",
      },
    ]);
    setMainCustomerList([
      {
        Id: 1,
        Name: "",
        Designation: "",
        ContactNumber: "",
        ContactEmail: "",
      },
    ]);
    setAddNewClicked(false);
    setSelectedNotifObj(null);
  };

  const subjectHandler = (e, type, newValue, newPlainTextValue) => {
    let tempString = newPlainTextValue;
    switch (type) {
      case REALTIME:
        setRealTimeSubject(e.target.value);
        setMentionRealTimeSubject(tempString);
        break;
      case HOURLY:
        setMentionHourlySubject(tempString);
        break;
      case DAILY:
        setMentionDailySubject(tempString);
        break;
      case WEEKLY:
        setMentionWeeklySubject(tempString);
        break;
      case MONTHLY:
        setMentionMonthlySubject(tempString);
        break;
      default:
        break;
    }
  };

  const messageHandler = (e, type, newValue, newPlainTextValue) => {
    let tempString = newPlainTextValue;
    switch (type) {
      case REALTIME:
        setRealTimeMessage(e.target.value);
        setMentionRealTimeMessage(tempString);
        break;
      case HOURLY:
        setMentionHourlyMessage(tempString);
        break;
      case DAILY:
        setMentionDailyMessage(tempString);
        break;
      case WEEKLY:
        setMentionWeeklyMessage(tempString);
        break;
      case MONTHLY:
        setMentionMonthlyMessage(tempString);
        break;
      case SMS:
        setSMSMessage(e.target.value)
        setMentionSMSMessage(tempString);
        break;
      case MOBILE:
        setMobileMessage(e.target.value)
        setMentionMobileMessage(tempString);
        break;
      default:
        break;
    }
  };

  const notifSelected = (item) => {
    if (
      item.NotificationConfigurationID ==
      selectedNotifObj?.NotificationConfigurationID
    ) {
      return;
    }
    if (selectedNotifObj != null && isNotifFormEnabled) {
      Swal.fire({
        title: "Operation in Progress.",
        text: "You have started the operation for a notification, do you want to discard any changes and continue to the other notification.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#027aaa",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          getNotificationById(item);
        }
      });
    } else {
      getNotificationById(item);
      setIsNotifFormEnabled(false);
      setIsEmptyForm(false);
    }
  };

  const getNotificationById = (item) => {
    getNotifById(item.NotificationConfigurationID)
      .then((res) => {
        if (res.Status == "success") {
          let item = res.Data;
          console.log("itemss", item)
          let tempCount = uniqueCount + 1;
          setUniqueCount(tempCount);
          setSelectedNotifObj(res.Data);
          setNotificationName(item.NotificationtemplateName);
          setCustomerSelected(item.NotificationConfigurationDetail.LstCustomer)
          let count = countkey + 1
          setCountKey(count)
          //getSiteListFn(item.NotificationConfigurationDetail.LstCustomer)
          setSiteSelectedArr(item.NotificationConfigurationDetail.LstSites)
          // let siteTempArr = siteListArray.filter((site) =>
          //   item.NotificationConfigurationDetail.LstSites.includes(site.value)
          // );
          // setSiteSelected(siteTempArr);
          // let deviceTypeArr = deviceTypeListArray.filter((device) =>
          //   item.NotificationConfigurationDetail.LstDeviecType.includes(
          //     device.value
          //   )
          // );
          // setDeviceTypeSelected(deviceTypeArr);
          let eventCodeArr = alertTypeOptions.filter((event) =>
            item.NotificationConfigurationDetail.LstEventCode.includes(
              event.value.toString()
            )
          );
          setEventCodeSelected(eventCodeArr);
          //Block to set value to email alert template.
          //1.RealTime
          let realTimeArr =
            item.NotificationConfigurationDetail.LstNotificationTemplateEmail.filter(
              (item) => item.Type == "RealTime"
            );
          console.log("realTimeArr", realTimeArr )
          if (realTimeArr.length > 0) {
            setRealTimeSubject(realTimeArr[0]?.Subject);
            setMentionRealTimeSubject(realTimeArr[0]?.Subject);
            setRealTimeMessage(realTimeArr[0]?.Body);
            setMentionRealTimeMessage(realTimeArr[0]?.Body);
            setRealTimeEnabled(String(realTimeArr[0]?.IsEnabled) == "true");
          } else {
            setRealTimeSubject("");
            setMentionRealTimeSubject("");
            setRealTimeMessage("");
            setMentionRealTimeMessage("");
            setRealTimeEnabled(false);
          }

          //2.Hourly
          let hourlyArr =
            item.NotificationConfigurationDetail.LstNotificationTemplateEmail.filter(
              (item) => item.Type == "Hourly"
            );
          if (hourlyArr.length > 0) {
            setMentionHourlySubject(hourlyArr[0].Subject);
            setMentionHourlyMessage(hourlyArr[0].Body);
            setHourlyEnabled(String(hourlyArr[0].IsEnabled) == "true");
          } else {
            setMentionHourlySubject("");
            setMentionHourlyMessage("");
            setHourlyEnabled(false);
          }

          //3.Daily
          let dailyArr =
            item.NotificationConfigurationDetail.LstNotificationTemplateEmail.filter(
              (item) => item.Type == "Daily"
            );
          if (dailyArr.length > 0) {
            setMentionDailySubject(dailyArr[0].Subject);
            setMentionDailyMessage(dailyArr[0].Body);
            setDailyEnabled(String(dailyArr[0].IsEnabled) == "true");
          } else {
            setMentionDailySubject("");
            setMentionDailyMessage("");
            setDailyEnabled(false);
          }

          //4.Weekly
          let weeklyArr =
            item.NotificationConfigurationDetail.LstNotificationTemplateEmail.filter(
              (item) => item.Type == "Weekly"
            );
          if (weeklyArr.length > 0) {
            setMentionWeeklySubject(weeklyArr[0].Subject);
            setMentionWeeklyMessage(weeklyArr[0].Body);
            setWeeklyEnabled(String(weeklyArr[0].IsEnabled) == "true");
          } else {
            setMentionWeeklySubject("");
            setMentionWeeklyMessage("");
            setWeeklyEnabled(false);
          }

          //5.Monthly
          let monthlyArr =
            item.NotificationConfigurationDetail.LstNotificationTemplateEmail.filter(
              (item) => item.Type == "Monthly"
            );
          if (monthlyArr.length > 0) {
            setMentionMonthlySubject(monthlyArr[0].Subject);
            setMentionMonthlyMessage(monthlyArr[0].Body);
            setMonthlyEnabled(String(monthlyArr[0].IsEnabled) == "true");
          } else {
            setMentionMonthlySubject("");
            setMentionMonthlyMessage("");
            setMonthlyEnabled(false);
          }

          //SMS 
          let SMSArr =
            item.NotificationConfigurationDetail.LstNotificationTemplateSMS
          if (SMSArr.length > 0) {
            setSMSMessage(SMSArr[0]?.Body);
            setMentionSMSMessage(SMSArr[0]?.Body);

          } else {
            setSMSMessage("");
            setMentionSMSMessage("");
          }
          //MOBILE 

          let mobileArr =
            item.NotificationConfigurationDetail.LstNotificationTemplateMobile
          if (mobileArr.length > 0) {
            setMobileMessage(mobileArr[0]?.Body);
            setMentionMobileMessage(mobileArr[0]?.Body);

          } else {
            setMobileMessage("");
            setMentionMobileMessage("");
          }
          // For Registered Users
          // setCustomContact(item.NotificationConfigurationDetail.LstCustomContact)
          if (
            item.NotificationConfigurationDetail.LstCustomContact.length == 0
          ) {
            let arr = [
              {
                Id: 0,
                Name: "",
                Designation: "",
                ContactNumber: "",
                ContactEmail: "",
              },
            ];
            setCount(0);
            setMainCustomerList(arr);
            setCustomContact(arr);
          } else {
            let initCount =
              item.NotificationConfigurationDetail.LstCustomContact[
                item.NotificationConfigurationDetail.LstCustomContact.length - 1
              ].Id;
            setCount(initCount);
            setMainCustomerList(
              item.NotificationConfigurationDetail.LstCustomContact
            );
            setCustomContact(
              item.NotificationConfigurationDetail.LstCustomContact
            );
          }
          let getEmergencyContact = false;
          if (item.NotificationConfigurationDetail.EmergencyContact == "yes") {
            getEmergencyContact = true;
          }
          setEmergencyContact(getEmergencyContact);
          setSelectedEmergCont(item.NotificationConfigurationDetail.LstEmergencyContact)
          setSelectedUsersList(
            item.NotificationConfigurationDetail.LstUserSite
          );
          setIsNotifFormEnabled(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onAddClick = (e) => {
    e.preventDefault();
    let lastForm = mainCustomerList[mainCustomerList.length - 1];
    let contactEmailEntered = lastForm?.ContactEmail;
    let contactNumberEntered = lastForm?.ContactNumber;
    const emailPattern = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm;

    if (enableAdd) {
      WarningToast("Please complete the contact details to add another");
      return;
    } else {
      console.log(
        "Button Clicked",
        count,
        contactEmailEntered,
        contactNumberEntered
      );
      if (
        contactEmailEntered != undefined &&
        contactNumberEntered != undefined
      ) {
        if (emailPattern.test(contactEmailEntered)) {
        } else {
          ErrorToast("Please enter email id properly");
          return;
        }
        if (contactNumberEntered.length != 10) {
          ErrorToast("Please enter contact number properly");
          return;
        }
      }
    }
    let c = count + 1;
    let tempObj = {
      Id: c,
      Name: "",
      Designation: "",
      ContactNumber: "",
      ContactEmail: "",
    };
    let tempArr = mainCustomerList;
    tempArr.push(tempObj);
    setMainCustomerList(tempArr);
    setCustomContact(tempArr);
    setCount(c);
  };

  const onDeleteClick = (e, id) => {
    e.preventDefault();
    let temp = customContact.filter((item) => item.Id == id);
    if (
      temp[0].Name === "" ||
      temp[0].Designation === "" ||
      temp[0].ContactNumber === "" ||
      temp[0].ContactEmail === ""
    ) {
      setEnableAdd(false);
    }
    let arr = mainCustomerList.filter((item) => item.Id != id);
    setMainCustomerList(arr);
    let arrTemp = customContact.filter((item) => item.Id != id);
    setCustomContact(arrTemp);
  };

  const filteredItems = notifList?.filter((item) => item?.NotificationtemplateName?.toLowerCase().includes(notifSearch.toLowerCase()))   

  const selectEntityHandler = (id) => {
    let arr = customerList.filter(c => c.id == id);
    setSelectedEntity(arr[0]);
    setSearchTextOne("");
    setSearchTextTwo("");
    setSearchTextThree("");
    setSearchTextFour("");
    setCheckOne(false);
    setCheckTwo(false);
    setTopLeftCheck(false);
    setTopRightCheck(false);
    setMidLeftCheck(false);
    setMidRightCheck(false);
    setIsLeftItemSelected(false);
    setIsLeftSearch(false);
    setIsRightSearch(false);
    setIsRightItemSelected(false);
    setIsEditCustomer(!isEditCustomer);
    let selectedString = arr[0].name.substring(0, arr[0].name.length - 3).toLowerCase();
    setFinalEntity(selectedString);
    // let parentIdsArr = nodes.map((item) => item.source);
    // let isParent = parentIdsArr.includes(selectedNode.id);
    // let tempParentId = 0
    // let tempChildId = 0
    // let sourceId = 0;

    // if (selectedNode.id == 1) {
    //     tempChildId = -1
    //     tempParentId = 0
    // } else {
    //     let tempNodes = nodes.filter((item) => item.id == selectedNode.id);
    //     tempParentId = tempNodes[0].parentId == 1 ? 0 : tempNodes[0].parentId
    //     tempChildId = selectedNode.id

    //     if (disableAdd) {
    //         tempChildId = -1
    //         if (isParent) {
    //             let tempNodes = nodes.filter((item) => item.id == selectedNode.id);
    //             tempParentId = tempNodes[0].parentId == 1 ? 0 : tempNodes[0].parentId
    //             tempChildId = selectedNode.id
    //         } else {
    //             for (let x = nodes.length - 1; x > 0; x--) {
    //                 if (nodes[x].type == "edge") {
    //                     sourceId = nodes[x].source;
    //                     tempParentId = sourceId;
    //                     break;
    //                 }
    //             }
    //         }
    //     }
    // }

    // if (sourceId == 1) {
    //     tempParentId = 0
    // }
    // if (selectedNode.id == 1) {
    //     tempChildId = -1
    //     tempParentId = 0
    // }
    // setFinalChildId(tempChildId);
    // setFinalParentId(tempParentId);

    let obj = {
      entity: selectedString,
      // fileName: groupName + "_" + localStorage.getItem('authCode'),
      // parentId: tempParentId,
      // childId: tempChildId,
      pageNumber: "1",
      pageType: "all"
    }
    // getMasterData(obj)
    //     .then(res => {
    //         if (res.Data) {
    //             let tempArr = res.Data.LstAvailable.map((item) => {
    //                 let obj = {
    //                     ...item,
    //                     isItSelected: false,
    //                 }
    //                 return obj;
    //             })
    //             let tempArrTwo = res.Data.LstSelected.map((item) => {
    //                 let obj = {
    //                     ...item,
    //                     isItSelected: false
    //                 }
    //                 return obj
    //             })
    //             setUnSelectedTemp(tempArr);
    //             setUnSelectedTempFiltered(tempArr);
    //             setSelectedTemp(tempArrTwo);
    //             setSelectedTempFiltered(tempArrTwo);
    //             setTotalPagesOne(parseInt(res.Data.TotalLengthAvailable));
    //             setTotalPagesTwo(parseInt(res.Data.TotalLengthSelected));
    //             setCurrentPageNoOne(1);
    //             setCurrentPageNoTwo(1);
    //             setPageCounterOne(1);
    //             setPageCounterTwo(1);
    //         }
    //     })
  }

  const selectAllHandler = (e, type) => {
    if (type === "ONE") {
      let temp = checkOne;
      setCheckOne(!checkOne);
      const tempArr = unselectedTempFiltered.map((item, index) => {
        let obj = {
          ...item,
          isItSelected: !checkOne
        }
        return obj;
      })
      if (temp) {
        setIsLeftItemSelected(false);
      } else {
        setIsLeftItemSelected(true);
      }
      setUnSelectedTemp(tempArr);
      setUnSelectedTempFiltered(tempArr);
    } else {
      let temp = checkTwo;
      setCheckTwo(!checkTwo);
      const tempArr = selectedTempFiltered.map((item, index) => {
        let obj = {
          ...item,
          isItSelected: !checkTwo
        }
        return obj
      })
      if (temp) {
        setIsRightItemSelected(false);
      } else {
        setIsRightItemSelected(true);
      }
      setSelectedTemp(tempArr);
      setSelectedTempFiltered(tempArr);
    }
  }

  const searchHandlerOne = (e) => {
    setSearchTextOne(e.target.value);
    if (e.target.value == "") {
      let obj = {
        entity: finalEntity,
        // fileName: groupName + "_" + localStorage.getItem('authCode'),
        // parentId: finalParentId,
        // childId: finalChildId,
        pageNumber: "1",
        pageType: "available",
        searchText: e.target.value
      }
      //getMasterFunc(obj, AVAILABLE);
      setIsLeftSearch(false);
    }
  }
  //region function end

  return (
    <>
      <div className="col-lg-12 mt-2">
        <div className="SiteMainContainer UserHgtContainer">
          <div className="SiteMainHeightDiv">
            <div className="SiteLeftContainer AutoHgtSiteScrollbar">
              <div className="m-2 HeaderSiteList">
                <input
                  id="Search_txt"
                  className="SearchViewInput1"
                  type="text"
                  placeholder="Search"
                  value={notifSearch}
                  onChange={(e) => setNotifSearch(e.target.value)}
                />
                <div className="SearchTextDivConfigTool">
                  {isDarkTheme ? (
                    <img className="EyeIcon" src={SearchIcon} alt="search icon" />
                  ) : (
                    <img
                      className="EyeIcon"
                      src={SearchIconWhite}
                      height="15"
                      alt="search icon"
                    />
                  )}
                </div>
              </div>
              <div className="NotificationList" style={{height:"auto"}}>
                {notifList &&
                  (filteredItems?.length > 0 ? (
                    filteredItems.map((item) => {
                      return (
                        <div
                          className={
                            selectedNotifObj?.NotificationConfigurationID ===
                              item.NotificationConfigurationID
                              ? "OneList SelectedList"
                              : "OneList"
                          }
                          key={item.NotificationConfigurationID}
                          onClick={(e) => {
                            e.stopPropagation();
                            notifSelected(item);
                            clearNotificationFields();
                          }}
                        >
                          <p className="ListofText">
                            {item.NotificationtemplateName}
                          </p>
                        </div>
                      );
                    })
                  ) : (
                    <div className="no-data-found">
                      <p>No Notification Found</p>
                    </div>
                  ))}
                {!notifList && (
                  <div className="no-data-found">
                    No Notifications Available
                  </div>
                )}
              </div>
            </div>

            <div className="SiteRightContainer UserMainFormDiv">
              <div className="userformContainer">
                <form>
                  <div className="Notification-form" style={{height:"calc(100vh - 200px)"}}>
                    <div className="inputMainContainer w40dot75rem mt30">
                      <div className="inputTypeLabelContainer">
                        <label className="formFieldLabels">Name</label>
                        <input
                          className="inputType"
                          placeholder="Enter notification name here"
                          value={notificationName}
                          onChange={(e) => {
                            setNotificationName(e.target.value);
                            setNotificationNameError("");
                          }}
                          disabled={!isNotifFormEnabled}
                        />
                        <p className="Error_P" style={{ float: "left" }}>
                          <span> {notificationNameError} </span>
                        </p>
                      </div>
                    </div>
                    {/* <div style={{width:"100%", float:"left", border: "1px solid #ebebeb", borderRadius: "5px" , display:"none" }}>
                    {
                    customerList.map((c) => (
                        c.selected === true ?
                            <div style={{ position: "relative", float: "left" }}>
                                <div className="customerInfoDiv">
                                    <div className="NodeTitleDescr">
                                        <p className='NodeHeading'>{c.name}</p>
                                        <p className='NodeDescreption'>
                                            Selected <span className='selectedCount'>{c.selectedCount}/{c.totalCount}</span>{" "}
                                        </p>
                                    </div>
                                    <div className="customerIconDiv">
                                        <OverlayTrigger
                                            placement='bottom'
                                            overlay={
                                                <Tooltip>
                                                    Add filter
                                                </Tooltip>
                                            }
                                        >
                                            <img
                                                src={AddFilter}
                                                alt="Addfilter"
                                              onClick={() => openTheMenu(c.id)}
                                                style={c.id == 10 ? { visibility: 'hidden' } : { visibility: 'block' }}
                                            />
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                            placement='bottom'
                                            overlay={
                                                <Tooltip>
                                                    Edit filter
                                                </Tooltip>
                                            }
                                        >
                                            <img
                                                src={EditFilter}
                                                alt="Editfilter"
                                                onClick={() => selectEntityHandler(c.id)}
                                            />
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                            placement='bottom'
                                            overlay={
                                                <Tooltip>
                                                    Remove filter
                                                </Tooltip>
                                            }
                                        >
                                            <img src={DeleteFilter}
                                                alt="Delete"
                                                style={c.id == 0 ? { visibility: 'hidden' } : { visibility: 'block' }}
                                                onClick={() => deleteMenu(c.id)}
                                            />
                                        </OverlayTrigger>
                                    </div>
                                </div>

                                {c.menuOpen && (
                                    <div className="customerFilter">
                                        <ul>
                                            {
                                                customerList.filter((element) => element.id > c.id).map((list) => (
                                                    <li
                                                        className="customerFilterList"
                                                        onClick={() => closeTheMenu(c.id, list.id)}
                                                        key={list.id}
                                                    >
                                                        {list.name}
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                )}
                            </div>
                            :
                            null
                    )
                    )
                } 
                      <div style={{ position: "relative", float: "left", display:"flex" }}>

                          <div className="customerInfoDiv">
                              <div className="NodeTitleDescr">
                                  <p className='NodeHeading'>devices</p>
                                  <p className='NodeDescreption'>
                                      Selected <span className='selectedCount'>200</span>{" "}
                                  </p>
                              </div>
                              <div className="customerIconDiv">
                                  <OverlayTrigger
                                      placement='bottom'
                                      overlay={
                                          <Tooltip>
                                              Add filter
                                          </Tooltip>
                                      }
                                  >
                                      <img
                                          src={AddFilter}
                                          alt="Addfilter"
                                          //onClick={() => openTheMenu(c.id)}
                                          //style={c.id == 10 ? { visibility: 'hidden' } : { visibility: 'block' }}
                                      />
                                  </OverlayTrigger>

                                  <OverlayTrigger
                                      placement='bottom'
                                      overlay={
                                          <Tooltip>
                                              Edit filter
                                          </Tooltip>
                                      }
                                  >
                                      <img
                                          src={EditFilter}
                                          alt="Editfilter"
                                          //onClick={() => selectEntityHandler(c.id)}
                                      />
                                  </OverlayTrigger>

                                  <OverlayTrigger
                                      placement='bottom'
                                      overlay={
                                          <Tooltip>
                                              Remove filter
                                          </Tooltip>
                                      }
                                  >
                                      <img src={DeleteFilter}
                                          alt="Delete"
                                          // style={c.id == 0 ? { visibility: 'hidden' } : { visibility: 'block' }}
                                          // onClick={() => deleteMenu(c.id)}
                                      />
                                  </OverlayTrigger>
                              </div>
                          </div>

                          <div className="customerFilter" style={{display:"none"}}>
                          <ul>
                              <li class="customerFilterList">Country(s)</li>
                              <li class="customerFilterList">State(s)</li>
                              <li class="customerFilterList">City(s)</li>
                              <li class="customerFilterList">Region(s)</li>
                              <li class="customerFilterList">Pin code(s)</li>
                              <li class="customerFilterList">Area(s)</li>
                              <li class="customerFilterList">Site(s)</li>
                              <li class="customerFilterList">Branch ID(s)</li>
                              <li class="customerFilterList">Device Type(s)</li>
                              <li class="customerFilterList">Device(s)</li>
                            </ul>
                          </div>


                      </div>
                    </div> */}

                <div className="grid-container Notificationgrid-container grid-container--fit mt20">
                  <div className="inputMainContainer w40dot75rem">
                    <div className="inputTypeLabelContainer">
                      <label className="formFieldLabels">Customer</label>
                      <select
                        name="CountryName"
                        // {...register("ClientId")}
                        //disabled={!isInterfaceEdit}
                        class="inputType ArrowSelectClass"
                        disabled={!isNotifFormEnabled}
                        value={customerSelected}
                        onChange={(e) => {
                          getSiteListFn(e.target.value)
                          setCustomerSelected(e.target.value)
                          setNotificationCustomerError("")
                        }}
                      >
                        <option key="0" disabled={false} value="0" id="0">
                          Select Customer
                        </option>
                        {clients?.map((item) => (
                          <option
                            value={item.ClientId}
                            key={item.ClientId}
                            id={item.ClientName}
                          >
                            {item.ClientName}
                          </option>
                        ))}
                      </select>
                      <p className="Error_P" style={{ float: "left" }}>
                        <span> {notificationCustomerError} </span>
                      </p>
                    </div>
                  </div>
                  <div className="inputMainContainer w40dot75rem">
                    <div className="inputTypeLabelContainer">
                      <label className="formFieldLabels">Site</label>
                      <MultiSelect
                        disabled={!isNotifFormEnabled}
                        options={siteListArray}
                        value={siteSelected}
                        onChange={(e) => {
                          setSiteSelected(e);
                          setNotificationSiteError("");
                        }}
                        labelledBy={"Select"}
                        overrideStrings={{
                          selectSomeItems: "Select site",
                          allItemsAreSelected: "All sites are selected",
                        }}
                        ArrowRenderer={() => <DropArrow />}
                      />
                      <p className="Error_P" style={{ float: "left" }}>
                        <span> {notificationSiteError} </span>
                      </p>
                    </div>
                  </div>
                  {/* <div className="inputMainContainer w40dot75rem">
                    <div className="inputTypeLabelContainer">
                      <label className="formFieldLabels">Device Type </label>
                      <MultiSelect
                        disabled={!isNotifFormEnabled}
                        options={deviceTypeListArray}
                        value={deviceTypeSelected}
                        onChange={(e) => {
                          setDeviceTypeSelected(e);
                          setNotificationDeviceTypeError("");
                        }}
                        labelledBy={"Select"}
                        overrideStrings={{
                          selectSomeItems: "Select device type",
                          allItemsAreSelected: "All devices are selected",
                        }}
                        ArrowRenderer={() => <DropArrow />}
                      />
                      <p className="Error_P" style={{ float: "left" }}>
                        <span> {notificationDeviceTypeError} </span>
                      </p>
                    </div>
                  </div> */}

                      <div className="inputMainContainer w40dot75rem">
                        <div className="inputTypeLabelContainer">
                          <label className="formFieldLabels">Event Code</label>
                          <MultiSelect
                            disabled={!isNotifFormEnabled}
                            options={alertTypeOptions}
                            value={eventCodeSelected}
                            onChange={(e) => {
                              setEventCodeSelected(e);
                              setNotificationEventCodeError("");
                            }}
                            labelledBy={"Select"}
                            overrideStrings={{
                              selectSomeItems: "Select event code type",
                              allItemsAreSelected: "All event codes are selected",
                            }}
                            ArrowRenderer={() => <DropArrow />}
                          />
                          <p className="Error_P" style={{ float: "left" }}>
                            <span> {notificationEventcodeError} </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="mt20" style={{ float: "left", width: "100%" }}>
                      <p className="SiteNameText">Email Notification Template</p>
                      <div className="NotificationEmailMsgBox">
                        <div className="EmailMsgBoxHeading">
                          <ul className="nav nav-pills">
                            <li
                              className="EmailNotificationNavItem"
                              disabled={!isNotifFormEnabled}
                            >
                              <a
                                className={
                                  selectedSiteTab == "realTime"
                                    ? "nav-link active bottom-three-sites"
                                    : "inactive-text-dashboard bottom-three-sites"
                                }
                                onClick={() => setSelectedSiteTab("realTime")}
                              >
                                <div className="Notificationcheckwithlabel">
                                  <input
                                    checked={realTimeEnabled}
                                    onChange={(e) =>
                                      setRealTimeEnabled(!realTimeEnabled)
                                    }
                                    type="checkbox"
                                    disabled={!isNotifFormEnabled}
                                    style={{ marginRight: "3px" }}
                                  />
                                  <label style={{ margin: "0px" }}>Real Time</label>
                                </div>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="tab-content">
                          {selectedSiteTab && selectedSiteTab == "realTime" && (
                            <>
                              <div className="startDiv">
                                <MentionsInput
                                  style={mentionsInputStyles}
                                  singleLine
                                  placeholder="Enter Subject here"
                                  disabled={!isNotifFormEnabled}
                                  value={realTimeSubject}
                                  onChange={(e, newValue, newPlainTextValue) =>
                                    subjectHandler(
                                      e,
                                      REALTIME,
                                      newValue,
                                      newPlainTextValue
                                    )
                                  }
                                  className="mentionList"
                                >
                                  <Mention
                                    data={mentionList}
                                    markup="{__display__}"
                                    style={mentionStyles}
                                  />
                                </MentionsInput>
                              </div>
                              <div className="EmailDivideLine"></div>
                              <div className="mentionDiv">
                                <MentionsInput
                                  style={mentionsInputStyles}
                                  placeholder="Enter message details here"
                                  rows={5}
                                  disabled={!isNotifFormEnabled}
                                  value={realTimeMessage}
                                  onChange={(e, newValue, newPlainTextValue) =>
                                    messageHandler(
                                      e,
                                      REALTIME,
                                      newValue,
                                      newPlainTextValue
                                    )
                                  }
                                  className="mentionList"
                                >
                                  <Mention
                                    data={mentionList}
                                    markup="{__display__}"
                                    style={mentionStyles}
                                  />
                                </MentionsInput>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="mt08" style={{ float: "left", width: "100%" , display:"none"}}>
                      <p className="SiteNameText">SMS</p>
                      <div className="NotificationEmailMsgBox">
                        <div className="tab-content">
                          {selectedSiteTab && selectedSiteTab == "realTime" && (
                            <>
                              <div className="mentionDiv">
                                <MentionsInput
                                  style={mentionsInputStyles}
                                  placeholder="Enter message details here"
                                  rows={5}
                                  disabled={!isNotifFormEnabled}
                                  value={smsMessage}
                                  onChange={(e, newValue, newPlainTextValue) => messageHandler(e, SMS, newValue, newPlainTextValue)}
                                >
                                  <Mention data={mentionList} markup="{__display__}" style={mentionStyles} />
                                </MentionsInput>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="mt08" style={{ float: "left", width: "100%", display:"none" }}>
                      <p className="SiteNameText">Mobile Notification</p>
                      <div className="NotificationEmailMsgBox">
                        <div className="tab-content">
                          {selectedSiteTab && selectedSiteTab == "realTime" && (
                            <>
                              <div className="mentionDiv">
                                <MentionsInput
                                  style={mentionsInputStyles}
                                  placeholder="Enter message details here"
                                  rows={5}
                                  disabled={!isNotifFormEnabled}
                                  value={mobileMessage}
                                  onChange={(e, newValue, newPlainTextValue) => messageHandler(e, MOBILE, newValue, newPlainTextValue)}
                                >
                                  <Mention data={mentionList} markup="{__display__}" style={mentionStyles} />
                                </MentionsInput>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <RegisteredUsers
                      selectedUsersList={selectedUsersList}
                      setSelectedUsersList={setSelectedUsersList}
                      isNotifFormEnabled={isNotifFormEnabled}
                      userList={userList}
                      setUserList={setUserList}
                      siteListString={siteListString}
                      selectedAllRegUsers={selectedAllRegUsers}
                      setSelectedAllRegUsers={setSelectedAllRegUsers}
                      isDarkTheme={isDarkTheme}
                      uniqueCount={uniqueCount}
                    />
                    {/* <EmergencyContact
                      selectedUsersList={selectedUsersList}
                      setSelectedUsersList={setSelectedUsersList}
                      isNotifFormEnabled={isNotifFormEnabled}
                      userList={userList} setUserList={setUserList}
                      siteListString={siteListString}
                      selectedAllRegUsers={selectedAllRegUsers}
                      setSelectedAllRegUsers={setSelectedAllRegUsers}
                      isDarkTheme={isDarkTheme}
                      emergencyContactList={emergencyContactList}
                      categoryMaster={categoryMaster}
                      setEmergencyContactList={setEmergencyContactList}
                      setCategoryMaster={setCategoryMaster}
                    /> */}

                    <CustomContact
                      addNewClicked={addNewClicked}
                      customContact={customContact}
                      setCustomContact={setCustomContact}
                      onAddClick={onAddClick}
                      isNotifFormEnabled={isNotifFormEnabled}
                      count={count}
                      mainCustomerList={mainCustomerList}
                      onDeleteClick={onDeleteClick}
                      setEnableAdd={setEnableAdd}
                      setMainCustomerList={setMainCustomerList}
                      isDarkTheme={isDarkTheme}
                    />
                  </div>
                </form>              
              </div>

              <div style={{ textAlign: "center",marginBottom:"10px" , display:"none"}}>
                  <button className="DataAccessEdit" style={{ width: "100px" }}>
                      <span className="ViewUpdate">Save</span>
                  </button>
                  <button className="DataAccessEdit" style={{ width: "100px" }}>
                      <span className="ViewUpdate">Edit</span>
                  </button>
                  <button className="DataAccessEdit" style={{ width: "100px" }}>
                      <span className="ViewUpdate">Update</span>
                  </button>
                  <button className="DataAccessEdit" style={{ width: "100px" }} type="submit">
                      <span className="ViewUpdate">Cancel</span>
                  </button>
              </div>
            </div>
          </div>
        </div>

        <EditModalContainer isDarkTheme={isDarkTheme}
          isEditCustomer={isEditCustomer}
          selectedEntity={selectedEntity}
          setTopLeftCheck={setTopLeftCheck}
          topLeftCheck={topLeftCheck}
          selectAllHandler={selectAllHandler}
          searchHandlerOne={searchHandlerOne}
          midLeftCheck={midLeftCheck}
          setMidLeftCheck={setMidLeftCheck}
        />

      </div>
    </>
  );
};

export default NotificationContainer;
